import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../context/AuthContext';
import heroVideo from '../../../assets/videos/hero-background.mp4';
import styles from './MainHeroSection.module.scss';

export const MainHeroSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuthContext();

    return (
        <section className={styles['hero']}>
            <video
                className={styles['hero__video']}
                autoPlay
                loop
                muted
                playsInline
            >
                <source src={heroVideo} type="video/mp4" />
            </video>

            <div className={styles['hero__overlay']} />

            <div className={styles['hero__content']}>
                <div className={styles['hero__heading']}>
                    <h1
                        className={styles['hero__title']}
                        data-no-animate
                        dangerouslySetInnerHTML={{ __html: t("landing.mainHero.title", "Expand your perspective on health") }}
                    />

                    <p className={styles['hero__sub']}>
                        {t("landing.mainHero.subheading", "Access professionals, valuable content, and a broader perspective to support your health journey.")}
                    </p>

                    <div className={styles['hero__cta-group']}>
                        {isAuthenticated ? (
                            <button
                                className={styles['hero__cta']}
                                onClick={() => navigate("/dashboard")}
                            >
                                {t("landing.heroSection.goDashboard", "Ir a mi panel")}
                            </button>
                        ) : (
                            <button
                                className={styles['hero__cta']}
                                onClick={() => navigate("/register")}
                            >
                                {t("landing.mainHero.notLoggedCta", "Crear mi cuenta")}
                            </button>
                        )}
                    </div>
                    {!isAuthenticated && (
                        <p className={styles['hero__note']} data-no-animate>
                            {t("landing.mainHero.note", "Creá tu cuenta sin costo y empezá a explorar profesionales y recursos.")}
                        </p>
                    )}
                </div>
            </div>
        </section>
    );
};
